import React from 'react'
import { MaybeLoaded } from 'json-react-layouts-data-loader'

import { ImageWidths } from 'common/helpers/image'

import { CommonCardProps } from 'component-library/cards/CardItem.Props'
import { LandscapeStacked } from 'component-library/cards/LandscapeStacked/LandscapeStacked'
import { Portrait } from 'component-library/cards/Portrait/Portrait'
import { StyledGridItem } from 'component-library/collections-new/Oscar/Oscar.styled'
import { CollectionEvent } from 'common/events/collection-events'
import { PublicationCardItem } from 'common/client-data-types/card-types'
import { MediaMode } from 'component-library/cards/CardMedia/CardMedia'

export interface Props extends CommonCardProps {
    imageWidths?: ImageWidths['thewest'] | ImageWidths['perthnow']
    disableImageLazyLoad?: boolean
    heroCardType: 'landscape-stacked' | 'portrait'
    mediaMode?: MediaMode
    hasPadding?: boolean
    onEvent: (event: CollectionEvent) => void
    cardNumber: number

    item: MaybeLoaded<PublicationCardItem>
}

export const HeroCard: React.FC<Props> = props => {
    const {
        onEvent,
        disableImageLazyLoad,
        imageWidths,
        heroCardType,
        mediaMode,
        hasPadding,
        item,
        cardNumber,
    } = props

    switch (heroCardType) {
        case 'landscape-stacked':
            return (
                <StyledGridItem>
                    <LandscapeStacked
                        item={item}
                        onEvent={onEvent}
                        disableImageLazyLoad={disableImageLazyLoad}
                        cardNumber={cardNumber}
                    />
                </StyledGridItem>
            )

        case 'portrait':
            return (
                <StyledGridItem>
                    <Portrait
                        item={item}
                        onEvent={onEvent}
                        disableImageLazyLoad={disableImageLazyLoad}
                        hideByline={true}
                        hideTeaser={true}
                        hideKicker={true}
                        fixedRatio={'16:9'}
                        mediaMode={mediaMode}
                        imageWidths={imageWidths}
                        hasBackground={true}
                        hasPadding={hasPadding}
                        fontScale={1}
                        cardNumber={cardNumber}
                    />
                </StyledGridItem>
            )

        default:
            return null
    }
}
